// Shared mutable UI state.
//
// Data lives in the store; this is only the view state — which tab, which person you
// are, which filters are on. One object so views can read and write it without a
// framework. main.js calls render() after anything here changes.

import { P } from "../data/people.js";
import { readLocal, writeLocal } from "./dom.js";

export const S = {
  /** Which teammate this browser is acting as. Per-device, not shared. */
  me: "pun",

  /** Active tab id: home | all | load | avail | read */
  tab: "home",

  /** All-work filters. cls and kind are on/off maps keyed by id. */
  filt: { cls: {}, kind: {}, hideDone: false, mine: false },

  /** Readings filters — class ids plus the special "__past" toggle. */
  readFilt: {},

  /** Load scope: window | semester | remaining */
  loadScope: "window",

  /** Availability view: "base" for the typical week, else a Monday ISO date. */
  weekKey: "base",
  availOverlap: false,
  addingClass: false,
  dragBlock: null,

  /** Item id being edited inline, or null. */
  editing: null,
  adding: false,
};

const ME_KEY = "ioh.me";

export function loadMe() {
  const saved = readLocal(ME_KEY, "pun");
  S.me = P[saved] ? saved : "pun";
  return S.me;
}

export function setMe(id) {
  if (!P[id]) return;
  S.me = id;
  writeLocal(ME_KEY, id);
}
